var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/updateChildItems.ts";
import "core-js/modules/es.array.reduce.js";
import { updateChildItem } from "./updateChildItem";
export function updateChildItems(nodes, newNodes) {
  return newNodes.reduce(updateChildItem, nodes);
}